<li *ngIf="columnFilter.value"
    class="nav-item"
    ngbTooltip="This is a column filter. It only applies to this tab."
    placement="top"
    container="body"
    autoClose="outside"
    >
  <button
       class="btn btn-sm border-dark"
       style="padding: 2px;"
       [ngClass]="{'ms-1': !isFirst}"
       [class.btn-light]="!columnFilter.isInvalid && !columnFilter.isDisabled"
       [class.btn-secondary]="!columnFilter.isInvalid && columnFilter.isDisabled"
       [class.btn-danger]="columnFilter.isInvalid">
    
    <!-- Icon container, shown on hover -->
    <span class="icon-container smaller-font">
      <!-- Left side: Enable/Disable Icon (First 50%) -->
      <span class="icon-left">
        <span 
          (click)="toggleColumnFilterIsDisable()"
          ngbTooltip="{{getTooltipText()}}"
          container="body"
          class="icon-padding"
          placement="bottom">
          <i *ngIf="columnFilter.isDisabled" class="fa-light fa-eye"></i>
          <i *ngIf="!columnFilter.isDisabled" class="fa-light fa-eye-slash"></i>
        </span>
      </span>

      <!-- Separator -->
      <span class="separator smaller-font"></span>

      <!-- Right side: Delete Icon (Second 50%) -->
      <span class="icon-right smaller-font">
        <!-- Delete Icon -->
        <span 
          (click)="removeColumnFilter()"
          ngbTooltip="Remove filter"
          container="body"
          class="icon-padding delete-icon"
          placement="bottom">
          <i class="fa-light fa-xmark"></i>
        </span>
      </span>
    </span>

    <div class="filter-label smaller-font">
      <i *ngIf="columnFilter.isInvalid" class="fa-light fa-circle-exclamation me-1"></i>
      <span [class.text-decoration-underline-hover]="!columnFilter.isDisabled"
            [class.text-decoration-filter-disabled]="columnFilter.isDisabled">
        <strong>{{columnFilter.label}}:</strong> {{columnFilter.value | truncate: 20: '...' }}
      </span>
    </div>
  </button>
</li>
